/* PBW: adds Horizon's circle-and-burst tick to product card Add buttons only when clicked, so product grids stay light. */
(function () {
  if (window.pbwBurst) return;
  var l = '';
  for (var i = 0; i < 8; i++) l += '<g style="--index: ' + i + ';"><line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"/></g>';
  window.pbwBurst = '<g class="check"><circle class="ring" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path class="tick" d="M9 12.75L11.25 15L15 9.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></g><g class="burst">' + l + '</g>';
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.quick-add-inline__button');
    var s = b && b.querySelector('.checkmark-burst');
    if (s && !s.querySelector('.ring')) s.innerHTML = window.pbwBurst;
  }, true);
})();
